import { render, staticRenderFns } from "./ReleasesView.vue?vue&type=template&id=26c2e390&scoped=true"
import script from "./ReleasesView.vue?vue&type=script&lang=js"
export * from "./ReleasesView.vue?vue&type=script&lang=js"
import style0 from "./ReleasesView.vue?vue&type=style&index=0&id=26c2e390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c2e390",
  null
  
)

export default component.exports